(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('KiosksDetailController', KiosksDetailController);

    KiosksDetailController.$inject = ['$scope', '$rootScope', 'entity'];

    function KiosksDetailController($scope, $rootScope, entity) {
        var vm = this;
        vm.kiosk = entity;

        var unsubscribe = $rootScope.$on('jotApp:kiosksUpdate', function(event, result) {
            vm.kiosk = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
